/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { UsersAdmin } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import { CheckOutlined } from '@ant-design/icons'
import { Button, Popconfirm, Tooltip } from 'antd'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { usersAdminSelector, validateUser, validateUserSelector } from 'src/features'

const UserAdminValidateButton: React.FC<{ user: UsersAdmin }> = ({ user }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { data: bigUsersList } = useAppSelector(usersAdminSelector)
  const { loading, currencUserId } = useAppSelector(validateUserSelector)

  const tooltip = {
    NO_VALIDATE: { label: t('Validate.ValidateUser'), color: 'blue' },
    VALIDATE: { label: t('Validate.UserValidated'), color: 'green' },
    REJECTED: { label: t('Validate.UserRejected'), color: 'black' },
  }[user.is_rejected ? 'REJECTED' : user.is_validate ? 'VALIDATE' : 'NO_VALIDATE']


  const buttonContent = (
    <Tooltip title={tooltip.label} color={tooltip.color}>
      <Button
        type='ghost'
        size='middle'
        shape='circle'
        loading={loading && user.id === currencUserId}
        icon={<CheckOutlined />}
        disabled={user.is_validate || user.is_rejected}
        className={`radius-100 ml-2`}
      />
    </Tooltip>
  )

  return <>
    {user.is_validate || user.is_rejected ? <>{buttonContent}</> : <Popconfirm
      title={t('Validate.SureValidate')}
      onConfirm={() => dispatch(validateUser(user.id, bigUsersList))}
      okText={t('general.Yes')}
      placement='bottom'
      cancelText={t('general.Cancel')}
    >
      {buttonContent}
    </Popconfirm>}
  </>
}

export default UserAdminValidateButton
